import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequesterService } from '../http-requester.service';
import { ApiEndpoints } from '../../constants/api-endpoints';
import { Provider, ProviderApiResponse } from '../../interfaces/provider.interface';
import { environment } from '../../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ProviderService {
  constructor(private readonly http: HttpRequesterService) {}

  registerSuperAdmin(formData: FormData): Observable<any> {
    return this.http.postFormData(ApiEndpoints.Provider.RegisterSuperAdmin, formData,  {
      headers: { 'x-error-handled': 'true' }
    });
  }

  searchProviders(filters: {
  providerId?: string;
  state?: string | number;
  lga?: string | number;
  providerName?: string;
}): Observable<any> {

  return this.http.get(ApiEndpoints.Provider.SearchProviders, filters);
}

  getAllProviders(filters: Record<string, any> = {}): Observable<ProviderApiResponse> {
  return this.http.get<ProviderApiResponse>(
    ApiEndpoints.Provider.GetAll,
    filters,
     {
      headers: { 'x-error-handled': 'true' }
    }
  );
}

getProviderById(id: number): Observable<Provider> {
  return this.http.get<Provider>(
    ApiEndpoints.Provider.GetById(id),
    null, // <-- params
    {
      headers: { 'x-error-handled': 'true' }
    }
  );
}

updateProviderById(id: number, payload: any): Observable<any> {
  return this.http.patch(ApiEndpoints.Provider.UpdateProviderById(id), payload, {
      headers: { 'x-error-handled': 'true' }
    });
}


  getProviderWithQuery(id: number): Observable<Provider> {
    return this.http.get<Provider>(ApiEndpoints.Provider.GetWithQueryId(id));
  }

  deleteProviderById(id: number): Observable<any> {
    return this.http.delete(ApiEndpoints.Provider.DeleteById(id),  null, // <-- params
    {
      headers: { 'x-error-handled': 'true' }
    });
  }

  linkProvider(payload: {
  providerId: number;
}): Observable<any> {
  return this.http.post(ApiEndpoints.Provider.LinkProvider, payload, {
      headers: { 'x-error-handled': 'true' }
    });
}

approveProvider(linkId: string): Observable<any> {
    return this.http.post(
      ApiEndpoints.Provider.ApproveProviderLink(linkId), 
      null,  // Assuming there's no body to send with the approval (adjust if necessary)
      {
        headers: { 'x-error-handled': 'true' }
      }
    );
  }

   rejectProvider(linkId: string, payload: { linkId: number,rejectionReason: string }): Observable<any> {
    return this.http.postFormData(
      ApiEndpoints.Provider.RejectProviderLink(linkId),
      payload, // Assuming there's no body to send with the rejection
      {
        headers: { 'x-error-handled': 'true' }
      }
    );
  }

  deactivateProvider(id: number): Observable<any> {
  return this.http.patch(
    ApiEndpoints.Provider.DeactivateProvider(id),
    null, // backend may not need body, adjust if required
    {
      headers: { 'x-error-handled': 'true' }
    }
  );
}

changeProviderStatus(id: number, status: boolean): Observable<any> {
  return this.http.patch(
    ApiEndpoints.Provider.ChangeStatus(id),
    status, // <-- sending only true/false
    {
      headers: { 'x-error-handled': 'true' }
    }
  );
}
  getAllExternalProviders(filters: Record<string, any> = {}): Observable<ProviderApiResponse> {
  return this.http.post(
    ApiEndpoints.Provider.externalList,
    filters,
     {
      headers: { 'x-error-handled': 'true' }
    }
  );
}


 getOnecareProviders(payload: any): Observable<any> {
    const url =
      `${environment.externalBaseUrlOnecare}` + `/api/MasterData/GetStateOrgListBySearch`;
    const headers = new HttpHeaders({
      'X-API-Key': environment.onecareApiKey,
      'x-error-handled': 'true',
    });

    return this.http.externalPost<any>(url, payload, { headers });
  }

   linkOnecareProviders(payload: any): Observable<any> {
    return this.http.post(ApiEndpoints.Provider.externalListLink, payload,  {
      headers: { 'x-error-handled': 'true' }
    });
  }
  relinkOnecareProviders(payload: any): Observable<any> {
    return this.http.post(ApiEndpoints.Provider.externalListRelink, payload,  {
      headers: { 'x-error-handled': 'true' }
    });
  }
  delinkOnecareProviders(payload: any): Observable<any> {
    return this.http.post(ApiEndpoints.Provider.externalListDelink, payload,  {
      headers: { 'x-error-handled': 'true' }
    });
  }


 getProviderTimeline(id: number): Observable<any> {
  return this.http.get(
    ApiEndpoints.Provider.GetProviderTimeline,
    { id },
    {
      headers: { 'x-error-handled': 'true' }
    }
  );
}
}
